import {
  filterObjectByArray,
  setMarksFromSubServices,
  setMarksFromSubServicesInGroup,
} from '@helpers/utils';
import {
  ADD_CATEGORY,
  ADD_EXPANDED_ELEMENT,
  ADD_GROUP,
  ADD_LEVEL,
  ADD_PATH,
  ADD_SERVICE,
  CatalogueActionTypes,
  CatalogueState,
  CLEAR_CATEGORIES,
  CLEAR_EXPANDED_ELEMENTS,
  CLEAR_GROUPS,
  CLEAR_LEVELS,
  CLEAR_SERVICES,
  END_LOADING,
  INIT_IS_POPULAR,
  SET_ANIMATION_DISABLED,
  SET_BLOCKED,
  SET_FROM_ROUTE,
  SET_IS_POPULAR,
  SET_LAST_OPENED_CATEGORY,
  START_LOADING,
  UPDATE_CATALOGUE,
  UPDATE_LEVELS,
  UPDATE_PATHS,
} from './types';

const initialState: CatalogueState = {
  id: 1,
  type: 'biznes',
  servicesCount: 0,
  rootCategories: [],
  categories: {},
  categoriesByPath: {},
  groups: [],
  services: [],
  levels: [],
  paths: [],
  expandedElements: [],
  lastOpenedCategory: null,
  isLoading: false,
  isBlocked: false,
  isPopular: false,
  animationDisabled: false,
  fromRoute: '',
};

export function catalogueReducer(
  state: CatalogueState = initialState,
  action: CatalogueActionTypes
): CatalogueState {
  var newCategory;
  var newCategoryByPath;

  switch (action.type) {
    case CLEAR_EXPANDED_ELEMENTS:
      return {
        ...state,
        expandedElements: [],
      };
    case SET_FROM_ROUTE:
      return {
        ...state,
        fromRoute: action.value,
      };
    case ADD_EXPANDED_ELEMENT:
      return {
        ...state,
        expandedElements: [action.elementId, ...state.expandedElements],
      };
    case ADD_LEVEL:
      return {
        ...state,
        levels: [action.categoryId, ...state.levels],
      };
    case UPDATE_LEVELS:
      return {
        ...state,
        levels: action.levels,
      };
    case ADD_PATH:
      return {
        ...state,
        paths: [action.path, ...state.paths],
      };
    case UPDATE_PATHS:
      return {
        ...state,
        paths: action.paths,
      };
    case CLEAR_LEVELS:
      return {
        ...state,
        levels: [],
      };
    case ADD_CATEGORY:
      newCategory = {
        [`${action.category.id}`]: action.category,
      };
      newCategoryByPath = {
        [action.category.routePath]: action.category,
      };
      return {
        ...state,
        categories: { ...state.categories, ...newCategory },
        categoriesByPath: { ...state.categoriesByPath, ...newCategoryByPath },
      };
    case CLEAR_CATEGORIES:
      return {
        ...state,
        categories: filterObjectByArray(
          state.categories,
          action.lockedCategories
        ),
      };
    case ADD_SERVICE:
      return {
        ...state,
        services: [...state.services, setMarksFromSubServices(action.service)],
      };
    case ADD_GROUP:
      return {
        ...state,
        groups: [...state.groups, setMarksFromSubServicesInGroup(action.group)],
      };
    case CLEAR_SERVICES:
      return {
        ...state,
        services: [],
      };
    case CLEAR_GROUPS:
      return {
        ...state,
        groups: [],
      };
    case UPDATE_CATALOGUE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_LAST_OPENED_CATEGORY:
      return {
        ...state,
        lastOpenedCategory: action.lastOpenedCategory,
      };
    case START_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case END_LOADING:
      return {
        ...state,
        isLoading: false,
      };
    case SET_BLOCKED:
      return {
        ...state,
        isBlocked: action.value,
      };
    case SET_ANIMATION_DISABLED:
      return {
        ...state,
        animationDisabled: action.value,
      };
    case INIT_IS_POPULAR: {
      return {
        ...state,
        isPopular: action.isPopular,
      };
    }
    case SET_IS_POPULAR: {
      return {
        ...state,
        isPopular: action.isPopular,
      };
    }
    default:
      return state;
  }
}
